import { formatNumberWithCommas } from '@src/v3/utils/helper';
import React from 'react';

const PropertyCardPills = ({
  bedroom,
  bath,
  squareFootage,
}: {
  bedroom: number | null;
  bath: number | null;
  squareFootage: number | null;
}) => {
  return (
    <div className="inline-flex items-center bg-[linear-gradient(180deg,#EDEDED_0%,#FFF_100%)] rounded-full px-2.5 py-1 border border-[#E5E7EB] shadow-md">
      <div className="flex items-center space-x-3 text-black-dark/50 text-base font-normal leading-normal tracking-[-0.48px]">
        {bedroom === 0 ? <span>Studio</span> : <span>{bedroom} bd</span>}
        <span className="text-[#C9C9C9] font-light">|</span>
        <span>{bath} ba</span>
        {squareFootage && squareFootage > 0 ? (
          <>
            <span className="text-[#C9C9C9] font-light">|</span>
            <span>{formatNumberWithCommas(squareFootage)} sqft</span>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default PropertyCardPills;
